var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.notifications)?_c('div',{staticClass:"notifications__list"},_vm._l((_vm.notifications),function(notification){return _c('custom-notification-widget',{key:notification.id,attrs:{"notification":notification}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }